<cs-button icon="wand" secondary (click)="openModelSelector($event)"></cs-button>
